import { pathOr, compose } from 'ramda'
import React, { useEffect, useMemo } from 'react'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Center from '../../../packages/kiti/components/helpers/Center'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import FormItem from '../../../packages/kiti/components/form/form/FormItem'
import { useForm, useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { Label } from '../../../packages/kiti/components/presentation/Text'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { isFunction } from '../../../packages/kiti/utils/helpers/types'
import { isEmpty } from 'lodash'
import TimeSelect, { convertToMinutes } from '../TimeSelect'

const DEFAULT_COL_WIDTH = 12.5

const ActionsCol = React.memo(({ path, index, remove, add }) => {
  return (
    <Col minWidth={4} justify={'center'}>
      <Center gutter={0.4} height={3}>
        <Col>
          <Icon name="BsPlus" color="dark3" onClick={() => add([...path, index])} />
        </Col>
        <Col>
          <Icon name="BsTrash" color="red" onClick={() => remove([...path, index])} />
        </Col>
      </Center>
    </Col>
  )
})

const InputCol = React.memo(({ path, field, index, width, ...props }) => (
  <Col minWidth={width || DEFAULT_COL_WIDTH}>
    <FormItem path={[...(path || []), field]} index={index} {...props} />
  </Col>
))

const WorkShiftsWeekDays = ({ path }) => {
  const form = useForm()
  const { addIn, handleChangeIn } = useFormState()

  let values = useMemo(() => {
    const initialState = [[{}], [{}], [{}], [{}], [{}], [{}], [{}]]
    return compose(values => (isEmpty(values) ? initialState : values))(pathOr(initialState, path, form))
  }, [path, form])

  useEffect(() => {
    handleChangeIn(['contract', 'workShifts'], values)
  }, [values, handleChangeIn])

  const fields = [
    {
      label: 'Início*',
      name: 'start',
      Input: TimeSelect
    },
    {
      label: 'Fim',
      name: 'end',
      Input: TimeSelect
    }
  ]

  const add = ([weekDayIndex, weekdayValuesIndex]) => {
    addIn(['contract', 'workShifts', weekDayIndex, weekdayValuesIndex + 1], {})
  }

  const remove = ([weekDayIndex, weekdayValuesIndex]) => {
    if (weekdayValuesIndex === 0) {
      values[weekDayIndex][weekdayValuesIndex] = {}
      handleChangeIn(['contract', 'workShifts'], values)
      return
    }
    values[weekDayIndex].splice(weekdayValuesIndex, 1)
    handleChangeIn(['contract', 'workShifts'], values)
  }

  const onChange = ([weekDayIndex, weekdayValuesIndex, name], value) => {
    values[weekDayIndex][weekdayValuesIndex][name] = value
    if (name === 'start') {
      const startValueInMinutes = convertToMinutes(value)
      const endValueInMinutes = convertToMinutes(values[weekDayIndex][weekdayValuesIndex]['end'])

      if (startValueInMinutes > endValueInMinutes) {
        values[weekDayIndex][weekdayValuesIndex]['end'] = null
      }
    }
    handleChangeIn(['contract', 'workShifts'], values)
  }

  const weekDays = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo']

  return (
    <div className="bulkForm">
      {weekDays.map((value, weekDayIndex) => {
        const weekdayValues = isEmpty(values[weekDayIndex]) ? [{}] : values[weekDayIndex]
        return (
          <Grid gutter={0.2} key={weekDayIndex} justify={'space-between'}>
            <Col width={'60px'} justify={'center'}>
              <Label>{value}</Label>
            </Col>
            <div key={weekDayIndex}>
              {weekdayValues.map((value, weekdayValuesIndex) => {
                return (
                  <Grid gutter={0.2} key={weekdayValuesIndex}>
                    {fields.map(({ name, width, label, disabled, dynamicProps, ...props }, index) => {
                      return (
                        <InputCol
                          key={name}
                          width={width}
                          path={['contract', 'workShifts', weekDayIndex, weekdayValuesIndex]}
                          field={name}
                          index={index}
                          value={weekdayValues[weekdayValuesIndex][name]}
                          showOnlySince={
                            name === 'start' ? null : convertToMinutes(weekdayValues[weekdayValuesIndex]['start'])
                          }
                          onChange={value => {
                            onChange([weekDayIndex, weekdayValuesIndex, name], value)
                          }}
                          {...props}
                          {...(isFunction(dynamicProps) ? dynamicProps(value) : {})}
                        />
                      )
                    })}
                    <ActionsCol
                      path={[weekDayIndex, weekdayValuesIndex]}
                      index={weekDayIndex}
                      add={add}
                      remove={remove}
                    />
                  </Grid>
                )
              })}

              <Separator size={0.4} />
            </div>
          </Grid>
        )
      })}

      <Separator weight={4} />
    </div>
  )
}

export default WorkShiftsWeekDays
